import {
  PARTNERS_REQUEST, PARTNERS_SUCCESS, PARTNERS_FAILURE,
  PARTNER_REQUEST, PARTNER_SUCCESS, PARTNER_FAILURE,
  PARTNER_ADD_REQUEST, PARTNER_ADD_SUCCESS, PARTNER_ADD_FAILURE,
  PARTNER_UPDATE_REQUEST, PARTNER_UPDATE_SUCCESS, PARTNER_UPDATE_FAILURE,
  PARTNER_DELETE_REQUEST, PARTNER_DELETE_SUCCESS, PARTNER_DELETE_FAILURE,
  PARTNER_ASSIGN_DISCOUNTS_REQUEST, PARTNER_ASSIGN_DISCOUNTS_SUCCESS, PARTNER_ASSIGN_DISCOUNTS_FAILURE,
  PARTNER_REMOVE_DISCOUNTS_REQUEST, PARTNER_REMOVE_DISCOUNTS_SUCCESS, PARTNER_REMOVE_DISCOUNTS_FAILURE,
  PARTNER_RESET
} from '../actions/partners'

const INITIAL_STATE = {
  partners: null,
  partnersNeedRefresh: false,
  partner: null,
  error: null,
  loading: false
}

const partnersReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case PARTNERS_REQUEST:
      return {
        ...state,
        partners: null,
        error: null,
        loading: true
      }
    case PARTNERS_SUCCESS:
      return {
        ...state,
        partners: action.response,
        partnersNeedRefresh: false,
        error: null,
        loading: false
      }
    case PARTNERS_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      }
    case PARTNER_REQUEST:
      return {
        ...state,
        error: null,
        loading: true
      }
    case PARTNER_SUCCESS:
      return {
        ...state,
        partner: action.response,
        error: null,
        loading: false
      }
    case PARTNER_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      }
    case PARTNER_ADD_REQUEST:
      return {
        ...state,
        error: null,
        loading: true
      }
    case PARTNER_ADD_SUCCESS:
      return {
        ...state,
        partner: action.response,
        partnersNeedRefresh: true,
        error: null,
        loading: false
      }
    case PARTNER_ADD_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      }
    case PARTNER_UPDATE_REQUEST:
      return {
        ...state,
        error: null,
        loading: true
      }
    case PARTNER_UPDATE_SUCCESS:
      return {
        ...state,
        partner: action.response,
        partnersNeedRefresh: true,
        error: null,
        loading: false
      }
    case PARTNER_UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      }
    case PARTNER_DELETE_REQUEST:
      return {
        ...state,
        error: null,
        loading: true
      }
    case PARTNER_DELETE_SUCCESS:
      return {
        ...state,
        partnersNeedRefresh: true,
        error: null,
        loading: false
      }
    case PARTNER_DELETE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      }
    case PARTNER_RESET:
      return {
        ...state,
        partner: null,
        error: null,
        loading: false
      }
    case PARTNER_ASSIGN_DISCOUNTS_REQUEST:
      return {
        ...state,
        error: null,
        loading: true
      }
    case PARTNER_ASSIGN_DISCOUNTS_SUCCESS:
      return {
        ...state,
        partner: action.response,
        partnersNeedRefresh: true,
        error: null,
        loading: false
      }
    case PARTNER_ASSIGN_DISCOUNTS_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      }
    case PARTNER_REMOVE_DISCOUNTS_REQUEST:
      return {
        ...state,
        error: null,
        loading: true
      }
    case PARTNER_REMOVE_DISCOUNTS_SUCCESS:
      return {
        ...state,
        partner: action.response,
        partnersNeedRefresh: true,
        error: null,
        loading: false
      }
    case PARTNER_REMOVE_DISCOUNTS_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      }
    default:
      return state
  }
}

export default partnersReducer